import {
  // Dashboard get All projects
  DEFAULT_LOGO_SUCCESS,
  PROJECTS_REQUEST,
  PROJECTS_SUCCESS,
  PROJECTS_FAIL,
  // Project Rename
  RENAME_PROJECT_REQUEST,
  RENAME_PROJECT_SUCCESS,
  RENAME_PROJECT_FAIL,
  // Template
  TEMPLATE_REQUEST,
  TEMPLATE_SUCCESS,
  TEMPLATE_FAIL,
  // Project Layout (Navbar / Sidebar / Preview / Options / Footer)
  PROJECT_REQUEST,
  PROJECT_SUCCESS,
  PROJECT_FAIL,
  PROJECT_CREATE_REQUEST,
  PROJECT_CREATE_SUCCESS,
  PROJECT_CREATE_FAIL,
  PROJECT_UPDATE_REQUEST,
  PROJECT_UPDATE_SUCCESS,
  PROJECT_UPDATE_FAIL,
  PROJECT_DELETE_REQUEST,
  PROJECT_DELETE_SUCCESS,
  PROJECT_DELETE_FAIL,
  // Crdit Reload Action
  PROJECT_CREDITS_UPDATE_REQUEST,
  PROJECT_CREDITS_UPDATE_SUCCESS,
  PROJECT_CREDITS_UPDATE_FAIL,
  PROJECT_CREDIT_OPTIONS_STATE_UPDATE,
  PROJECT_CREDITS_ITEMS_UPDATE_SUCCESS,
  CURRENT_BLOCK_UPDATE,
  UNDO_REDO_SET_STATE,

  // UploadLogo in Block
  PROJECT_LOGO_UPLOAD_SUCCESS,

  // Sidebar block move
  BLOCK_MOVE,
  // Setting Options
  OPTION_REQUEST,
  PROJECT_OPTION_SUCCESS,
  SETTING_OPTION_STATE,
  PROJECT_SETTINGS_UPDATE_SUCCESS,
  // FontStyles
  FONT_STYLE_UPDATE,
  PROJECT_FONTSTYLE_UPDATE_SUCCESS,
  // Render Export
  PROJECT_RENDER_REQUEST_SUCCESS,
  RENDER_DELETE_FAIL,
  RENDER_DELETE_SUCCESS,
  RENDER_DELETE_All_SUCCESS,
  RENDER_DELETE_ALL_FAIL,
  DOWNLOAD_RENDER_REQUEST,
  CARD_PROJECT_SUCCESS,
  CARD_PROJECT_FAIL,
  PROJECT_GLOBAL_OPTION_SUCCESS,
  USER_STRIPE_DATA_SUCCESS,
  USER_STRIPE_DATA_FAIL,
  HELP_PAGE_FAIL,
  PROJECT_SCROLL_GLOBAL_OPTION_SUCCESS,
  CUSTOM_FONTS_LOAD_SUCCESS,
} from "./types";
import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
} from "../../services/axios";
import store from "../store";
import UndoRedo from "../../UndoRedoClass";
import { toast } from "react-toastify";
import CustomToast, { customToatStyle } from "../../Components/CustomToast/CustomToast";

const returnToastNotify = async (key, value) => {
  if (key === "double_columns" && (value || !value)) {
    const column =
      key === "double_columns" && value
        ? "Double Column Set"
        : key === "double_columns" && !value
          ? "Single Column Set"
          : "";
    return toast.success("saving...", { autoClose: 300 });
  } else if (key === "name_on_left" && (value || !value)) {
    const name =
      key === "name_on_left" && value
        ? "Name Set On Left"
        : key === "name_on_left" && !value
          ? "Name Set On Right"
          : "";
    return toast.success("saving...", { autoClose: 300 });
  } else if (
    key === "block_inset" &&
    (value === "default" ||
      value === "left" ||
      value === "right" ||
      value === "sidebyside")
  ) {
    const blockInset = `Block Inset Set ${value}`;
    return toast.success("saving...");
  } else if (key === "margin_vertical") {
    const margin = `Vertical Margin Set ${value} %`;
    return toast.success("saving...", { autoClose: 300 });
  }
};

// Create project
export const createProject = (data) => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_CREATE_REQUEST });
    const { data: projectData } = await postRequest(`/project/`, data);
    const { project } = projectData;
    dispatch({
      type: PROJECT_CREATE_SUCCESS,
      payload: {
        project,
      },
    });
  } catch (error) {
    dispatch({
      type: PROJECT_CREATE_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

// Create project By Google
export const createAGoogleProject =
  (projectName, templateId) => async (dispatch) => {
    try {
      dispatch({ type: PROJECT_CREATE_REQUEST });
      const projectRoute =
        process.env.REACT_APP_PROJECT_CREATE_ROUTE || "byGoogle";
      const projectData = await postRequest(`/project/${projectRoute}`, {
        // title: `Google Project ${new Date().toDateString()}${Date.now()}`, //Will update it by user entered value
        title: projectName,
        templateId: templateId ? templateId : 0,
      });
      const { project } = projectData?.data || {};
      if (project) {
        dispatch({
          type: PROJECT_CREATE_SUCCESS,
          payload: {
            project,
          },
        });
        return projectData?.data;
      } else {
        return projectData?.response?.data || projectData?.data;
      }
    } catch (error) {
      dispatch({
        type: PROJECT_CREATE_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
      return error;
    }
  };

export const createCardProject =
  (projectName, templateId, resolution) => async (dispatch) => {
    try {
      dispatch({ type: PROJECT_CREATE_REQUEST });
      const projectRoute =
        process.env.REACT_APP_PROJECT_CREATE_ROUTE || "byGoogle";
      const projectData = await postRequest(`/project/createACardProject`, {
        title: projectName,
        resolution: resolution,
        templateId: templateId ? templateId : 0,
      });
      const { cardProject } = projectData?.data || {};
      if (cardProject) {
        dispatch({
          type: CARD_PROJECT_SUCCESS,
          payload: {
            cardProject,
          },
        });
        return projectData?.data;
      } else {
        return projectData?.response?.data || projectData?.data;
      }
    } catch (error) {
      dispatch({
        type: CARD_PROJECT_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
      return error;
    }
  };

// rename project
export const renameProject =
  (projectId, projectName, isCard) => async (dispatch) => {
    try {
      dispatch({ type: PROJECT_REQUEST });
      let update_response;

      if (!isCard) {
        update_response = await putRequest(
          `/project/updateTitle/${projectId}`,
          {
            name: projectName,
          },
        );
      } else if (isCard) {
        update_response = await putRequest(
          `/project/updateCardTitle/${projectId}`,
          {
            name: projectName,
          },
        );
      }
      const { updatedProject } = update_response?.data;
      dispatch({
        type: RENAME_PROJECT_SUCCESS,
        payload: {
          updatedProject,
        },
      });
      return update_response?.data;
    } catch (error) {
      dispatch({
        type: RENAME_PROJECT_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };

// Clone project
export const cloneProject =
  (sourceProjectId, title, isCard) => async (dispatch) => {
    try {
      dispatch({ type: PROJECTS_REQUEST });
      let responseData;
      if (!isCard) {
        responseData = await postRequest("/project/clone", {
          sourceProjectId,
          title,
        });
      } else if (isCard) {
        responseData = await postRequest("/project/cloneACardProject", {
          sourceProjectId,
          title,
        });
      }
      const { project } = responseData?.data || {};
      if (responseData?.data?.success) {
        dispatch({
          type: PROJECT_CREATE_SUCCESS,
          payload: {
            project,
          },
        });
        return responseData;
      } else {
        return responseData;
      }
    } catch (error) {
      dispatch({
        type: PROJECT_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
      return error;
    }
  };

// Get project
export const getProjectDetails = (projectId, isCard) => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_REQUEST });
    let response;
    if (!isCard) {
      response = await getRequest(`/project/${projectId}`);
    } else {
      response = await getRequest(`/project/getCardProject/${projectId}`);
    }
    if (response?.data?.success) {
      const {
        credits,
        fontStyle,
        settings,
        members,
        logos,
        _id,
        googleSpreadSheetId,
        googleSheetLink,
        isVideoGenerated,
        renders,
        resolution,
        title,
        isCard,
      } = response?.data?.project;

      dispatch({
        type: PROJECT_SUCCESS,
        payload: {
          _id,
          credits,
          fontStyle,
          settings,
          members,
          logos,
          googleSheetLink,
          googleSpreadSheetId,
          currentBlock: { idx: 0, id: credits[0]?._id },
          isVideoGenerated,
          renders,
          resolution,
          title,
          isCard,
        },
      });
      const project = store.getState().project;
      const objectsMap = project.credits.map((credit, index) => {
        const obj = new UndoRedo();
        obj.push(credit.options);
        return { obj: obj, index: index };
      });
      dispatch({ type: UNDO_REDO_SET_STATE, payload: objectsMap });
    } else {
      // handle unsuccessful response here
    }
    return response;
  } catch (error) {
    dispatch({
      type: PROJECT_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
    return error;
  }
};

// Delete project
export const deleteAProject = (projectId, isCard) => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_DELETE_REQUEST });
    // const { data: projectData } = await deleteRequest(`/project/${projectId}`);
    let response;
    if (!isCard) {
      response = await deleteRequest(`/project/${projectId}`);
    } else if (isCard) {
      response = await deleteRequest(`/project/deleteCardProject/${projectId}`);
    }
    const { data: projectData } = response;

    dispatch({
      type: PROJECT_DELETE_SUCCESS,
      payload: { projectId: projectData.projectId },
    });
  } catch (error) {
    dispatch({
      type: PROJECT_DELETE_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

// Update Project Status

export const updateProjectStatus =
  (projectId, projectStatus, idx, isCard) => async (dispatch) => {
    try {
      dispatch({ type: RENAME_PROJECT_REQUEST });
      let updateStatusResponse;
      if (!isCard) {
        updateStatusResponse = await putRequest(
          `/project/updateProjectStatus/${projectId}`,
          { projectStatus: projectStatus, statusId: idx },
        );
      } else if (isCard) {
        updateStatusResponse = await putRequest(
          `/project/updateCardStatus/${projectId}`,
          { projectStatus: projectStatus, statusId: idx },
        );
      }
      const { updatedProject } = updateStatusResponse?.data;
      dispatch({
        type: RENAME_PROJECT_SUCCESS,
        payload: { updatedProject },
      });
    } catch (error) {
      dispatch({
        type: RENAME_PROJECT_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// For Card Layout Navbar  Sync/Reload (Credit Sheet)

// Sync/ Reload By GoogleSheet
export const updateProjectCreditsByGoogle =
  (projectId, spreadsheetId, credit, isCard) => async (dispatch) => {
    try {
      dispatch({ type: PROJECT_CREDITS_UPDATE_REQUEST });
      let data;
      if (!isCard) {
        data = await putRequest(`/project/${projectId}/credits/byGoogle`, {
          credit,
          projectId,
          spreadsheetId,
        });
      } else if (isCard) {
        data = await putRequest(`/project/card/${projectId}/credits/byGoogle`, {
          credit,
          projectId,
          spreadsheetId,
        });
      }
      if (data?.data?.success) {
        let {
          credits,
          fontStyle,
          settings,
          members,
          logos,
          _id,
          googleSpreadSheetId,
          googleSheetLink,
          isVideoGenerated,
          renders,
          title,
        } = data?.data?.project;

        dispatch({
          type: PROJECT_CREDITS_UPDATE_SUCCESS,
          payload: {
            title,
            _id,
            credits,
            fontStyle,
            settings,
            members,
            logos,
            googleSheetLink,
            googleSpreadSheetId,
            currentBlock: { idx: 0, id: credits[0]?._id },
            isVideoGenerated,
            renders,
          },
        });
        const project = store.getState().project;

        const objectsMap = project.credits.map((credit, index) => {
          const obj = new UndoRedo();
          obj.push(credit.options);
          return { obj: obj, index: index };
        });

        dispatch({ type: UNDO_REDO_SET_STATE, payload: objectsMap });
        return data?.data;
      } else {
        return data;
      }
    } catch (error) {
      dispatch({
        type: PROJECT_CREDITS_UPDATE_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };

// Sync By File Sheet
export const updateProjectCredits =
  (projectId, credits) => async (dispatch) => {
    try {
      dispatch({ type: PROJECT_CREDITS_UPDATE_REQUEST });
      const { data } = await putRequest(`/project/${projectId}/credits/`, {
        credits,
      });

      dispatch({
        type: PROJECT_CREDITS_UPDATE_SUCCESS,
        payload: {
          credits: data.credits,
        },
      });
      const project = store.getState().project;
      const objectsMap = project.credits.map((credit, index) => {
        const obj = new UndoRedo();
        obj.push(credit.options);
        return { obj: obj, index: index };
      });
      dispatch({ type: UNDO_REDO_SET_STATE, payload: objectsMap });
    } catch (error) {
      dispatch({
        type: PROJECT_CREDITS_UPDATE_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Select Current Block Id From Sidebar And Preview
export const updateCurrentBlockState = (id, idx) => async (dispatch) => {
  dispatch({
    type: CURRENT_BLOCK_UPDATE,
    payload: {
      id,
      idx,
    },
  });
};

//drag and drop action
export const moveBlock = (sourceIdx, targetIdx) => async (dispatch) => {
  dispatch({
    type: BLOCK_MOVE,
    payload: {
      sourceIdx,
      targetIdx,
    },
  });
};

// Options - Select Type => Font/Layout
export const selectedOption = (isOptionSelected) => (dispatch) => {
  try {
    dispatch({ type: OPTION_REQUEST });
    dispatch({
      type: PROJECT_OPTION_SUCCESS,
      payload: isOptionSelected,
    });
  } catch (error) {
    return error;
  }
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Options - Blocks(RoleName/NameOnly/Blurb/Songs) - Call Both Function
export const updateProjectCreditOptionsState =
  (creditsIdx, optionKey, optionValue) => (dispatch) => {
    dispatch({
      type: PROJECT_CREDIT_OPTIONS_STATE_UPDATE,
      payload: {
        creditsIdx,
        optionKey,
        optionValue,
      },
    });
  };

const optionSaveTimers = {};
const optionSaveSeq = {};
const optionSavePending = {};

export const saveOptionById =
  (creditsId, isCard, currentBlockOptions) => (dispatch) => {
    if (!creditsId) {
      dispatch({
        type: PROJECT_FAIL,
        payload: { error: "Error: no current options id to save" },
      });
      return;
    }

    // Collapse rapid radio toggles into one save of the latest store state.
    // A sequence token drops stale HTTP responses so they cannot snap the UI back.
    optionSaveSeq[creditsId] = (optionSaveSeq[creditsId] || 0) + 1;
    const seq = optionSaveSeq[creditsId];
    optionSavePending[creditsId] = { isCard, currentBlockOptions };

    if (optionSaveTimers[creditsId]) {
      clearTimeout(optionSaveTimers[creditsId]);
    }

    return new Promise((resolve) => {
      optionSaveTimers[creditsId] = setTimeout(async () => {
        optionSaveTimers[creditsId] = null;
        const pending = optionSavePending[creditsId] || {
          isCard,
          currentBlockOptions,
        };

        try {
          const { credits, _id: projectId } = store.getState().project;
          const idx = credits.findIndex((credit) => credit._id == creditsId);
          if (idx == -1) throw Error("Error in saving options");

          const optionsToSave = pending.currentBlockOptions || credits[idx].options;

          const url = pending.isCard
            ? `/project/card/${projectId}/credits/${creditsId}/options`
            : `/project/${projectId}/credits/${creditsId}/options`;

          const { data } = await putRequest(url, optionsToSave);

          if (seq !== optionSaveSeq[creditsId]) {
            resolve();
            return;
          }

          if (data?.success) {
            dispatch({
              type: PROJECT_OPTION_SUCCESS,
              payload: {
                creditsId,
                preserveOptions: true,
              },
            });
          }
          resolve();
        } catch (error) {
          if (seq === optionSaveSeq[creditsId]) {
            dispatch({
              type: PROJECT_FAIL,
              payload: {
                error:
                  error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
              },
            });
          }
          resolve();
        }
      }, 200);
    });
  };

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// updateSettingOptionState // Aditional Extra Global Settings - Gutter / Ragged Gutter (In Footer)
export const updateSettingOptionState =
  (settingsKey, settingsvalue) => async (dispatch) => {
    dispatch({
      type: SETTING_OPTION_STATE,
      payload: {
        settingsKey,
        settingsvalue,
      },
    });
  };

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const updateFontStyleState =
  (key, property, value, currentBlockType) => async (dispatch) => {
    if (currentBlockType === "nameonly" && key === "name") {
      key = "nameOnlyStyle";
      dispatch({
        type: FONT_STYLE_UPDATE,
        payload: { key, property, value },
      });
    } else if (
      currentBlockType === "rolename" &&
      key === "role" &&
      property === "lineHeight"
    ) {
      key = "role";
      dispatch({
        type: FONT_STYLE_UPDATE,
        payload: { key, property, value },
      });
    } else {
      dispatch({
        type: FONT_STYLE_UPDATE,
        payload: { key, property, value },
      });
    }
  };

// Font Settings
export const saveFontStyle =
  (fontStyleType, currentBlockType, key, value, notifyWithToast, isCard) =>
    async (dispatch) => {
      console.log("fontStyleType:", fontStyleType);
      console.log("isCard:", isCard);

      try {
        dispatch({ type: PROJECT_REQUEST });

        const { _id: projectId, fontStyle } = store.getState().project;
        console.log("projectId:", projectId);

        const fontStylePreBody = fontStyle?.fontStyleBody;
        const { _id, ...newFontStyle } = fontStyle?.[fontStyleType] || {};
        console.log("newFontStyle:", newFontStyle);

        // Proceed only if the fontStyle body is different
        if (
          typeof fontStylePreBody === "undefined" ||
          JSON.stringify(fontStylePreBody) !==
          JSON.stringify(fontStyle?.[fontStyleType])
        ) {
          const url = isCard
            ? `/project/card/${projectId}/fontStyle/${fontStyleType}`
            : `/project/${projectId}/fontStyle/${fontStyleType}`;
          console.log("Request URL:", url);
          const { data } = await putRequest(url, newFontStyle);

          if (data?.success) {
            dispatch({
              type: PROJECT_FONTSTYLE_UPDATE_SUCCESS,
              payload: {
                fontStyle: data.fontStyle,
                fontStyleType,
                fontStyleBody: fontStyle?.[fontStyleType],
              },
            });

            // Optional: enable toast
            // notifyWithToast?.({ keyName: key, value, data: data?.success });
          }
        }
      } catch (error) {
        dispatch({
          type: PROJECT_FAIL,
          payload: {
            error: error.response?.data?.message || error.message,
          },
        });
      }
    };

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const updateAProjectCreditItemsState =
  (creditsId, items) => (dispatch) => {
    dispatch({
      type: PROJECT_CREDITS_ITEMS_UPDATE_SUCCESS,
      payload: {
        items,
        creditsId,
      },
    });
  };

export const saveProjectSettings = () => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_REQUEST });
    let { _id: projectId, settings, isCard } = store.getState().project;
    if (settings.variant === null || settings.variant === undefined)
      settings.variant = " ";
    delete settings._id;
    const settingsUrl = isCard
      ? `/project/${projectId}/settings/?isCard=true`
      : `/project/${projectId}/settings/`;
    const { data } = await putRequest(settingsUrl, settings);

    dispatch({
      type: PROJECT_SETTINGS_UPDATE_SUCCESS,
      payload: {
        settings: data.settings,
      },
    });
  } catch (error) {
    dispatch({
      type: PROJECT_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// save global screen option for cards
export const saveGlobalOption =
  (creditsId, currentBlockChangedOptions) => async (dispatch) => {
    try {
      dispatch({ type: PROJECT_REQUEST });

      if (!creditsId) throw Error("Error: no current options id to save");

      const { credits, _id: projectId } = store.getState().project;
      const idx = credits.findIndex((credit) => credit._id == creditsId);
      if (idx == -1) throw Error("Error in saving options");
      const options = credits[idx].options;

      const url = `/project/card/${projectId}/credits/${creditsId}/global-options`;

      if (currentBlockChangedOptions) {
        const { data } = await putRequest(url, currentBlockChangedOptions);
        if (data?.success) {
          dispatch({
            type: PROJECT_GLOBAL_OPTION_SUCCESS,
            payload: {
              updatedOptions: currentBlockChangedOptions,
            },
          });
        }
      }
    } catch (error) {
      dispatch({
        type: PROJECT_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };

export const saveProjectGlobalOption =
  (creditsId, currentBlockChangedOptions, block_type, isCard) =>
    async (dispatch) => {
      try {
        dispatch({ type: PROJECT_REQUEST });

        if (!creditsId) throw Error("Error: no current options id to save");

        const { credits, _id: projectId } = store.getState().project;
        const idx = credits.findIndex((credit) => credit._id == creditsId);
        if (idx == -1) throw Error("Error in saving options");
        const options = credits[idx].options;

        const url = `/project/${projectId}/credits/${creditsId}/global-options`;

        if (currentBlockChangedOptions) {
          const { data } = await putRequest(url, {
            block_type,
            currentBlockChangedOptions,
            isCard,
          });
          if (data?.success) {
            dispatch({
              type: PROJECT_SCROLL_GLOBAL_OPTION_SUCCESS,
              payload: {
                updatedProjectOptions: data?.options,
                block_type,
                currentBlockChangedOptions,
              },
            });
          }
        }
      } catch (error) {
        dispatch({
          type: PROJECT_FAIL,
          payload: {
            error:
              error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
          },
        });
      }
    };

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Undo/Redo
export const undoOptions = (creditsId) => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_REQUEST });

    if (!creditsId) throw Error("Error: no current options id to save");
    const { credits, _id: projectId } = store.getState().project;
    const idx = credits.findIndex((credit) => credit._id == creditsId);
    if (idx == -1) throw Error("Error in saving options");
    const obj = store.getState().undoRedo[idx].obj;

    const options = obj.getPreviousState;
    //setting state optimisticly
    dispatch({
      type: PROJECT_OPTION_SUCCESS,
      payload: {
        options: options,
        creditsId,
      },
    });
    const { data } = await putRequest(
      `/project/${projectId}/credits/${creditsId}/options`,
      options,
    );
    //experimenting
    /*dispatch({
        type: PROJECT_OPTION_SUCCESS,
        payload: {
          options: data.options,
          creditsId,
        },
      });*/
  } catch (error) {
    //reverting state
    const { credits, _id: projectId } = store.getState().project;
    const idx = credits.findIndex((credit) => credit._id == creditsId);
    if (idx == -1) throw Error("Error in saving options");
    const obj = store.getState().undoRedo[idx].obj;
    const options = obj.getNextState;
    dispatch({
      type: PROJECT_OPTION_SUCCESS,
      payload: {
        options: options,
        creditsId,
      },
    });
    dispatch({
      type: PROJECT_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

export const redoOptions = (creditsId) => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_REQUEST });

    if (!creditsId) throw Error("Error: no current options id to save");
    const { credits, _id: projectId } = store.getState().project;
    const idx = credits.findIndex((credit) => credit._id == creditsId);
    if (idx == -1) throw Error("Error in saving options");
    const obj = store.getState().undoRedo[idx].obj;

    const options = obj.getNextState;
    //setting state optimisticly
    dispatch({
      type: PROJECT_OPTION_SUCCESS,
      payload: {
        options: options,
        creditsId,
      },
    });
    const { data } = await putRequest(
      `/project/${projectId}/credits/${creditsId}/options`,
      options,
    );
    //Experimenting
    /*dispatch({
        type: PROJECT_OPTION_SUCCESS,
        payload: {
          options: data.options,
          creditsId,
        },
      });*/
  } catch (error) {
    //reverting state
    const { credits, _id: projectId } = store.getState().project;
    const idx = credits.findIndex((credit) => credit._id == creditsId);
    if (idx == -1) throw Error("Error in saving options");
    const obj = store.getState().undoRedo[idx].obj;
    const options = obj.getPreviousState;
    dispatch({
      type: PROJECT_OPTION_SUCCESS,
      payload: {
        options: options,
        creditsId,
      },
    });
    dispatch({
      type: PROJECT_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Get Default Logo
export const getDefalutLogos = () => async (dispatch) => {
  try {
    dispatch({ type: PROJECTS_REQUEST });
    const isCard = JSON.parse(localStorage.getItem("isCard"));
    const response = await postRequest(
      `/project/getDefaultImages?isCard=${isCard}`,
    );
    if (response?.data?.success) {
      let defaultLogos = [];
      // defaultLogos = [...response.data.users_logos];
      defaultLogos = [
        ...response.data.users_logos,
        ...response.data.formattedLogos,
      ];
      dispatch({
        type: DEFAULT_LOGO_SUCCESS,
        payload: defaultLogos,
      });
      return response?.data;
    } else {
      dispatch({
        type: PROJECTS_FAIL,
        payload: {
          error: response,
        },
      });
      return response;
    }
  } catch (error) {
    dispatch({
      type: PROJECTS_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

// Upload Logo
export const uploadLogoDetails = (filedata, creditID) => async (dispatch) => {
  console.log("3 API call upload logo");
  try {
    dispatch({ type: PROJECTS_REQUEST });
    const { _id: projectId } = store.getState().project;
    const response = await postRequest(
      `/project/${projectId}/${creditID}/logoUpload`,
      filedata,
    );
    console.log("4 API call Response upload logo response => ", response);
    if (response?.data?.success) {
      dispatch({
        type: PROJECT_LOGO_UPLOAD_SUCCESS,
        payload: {
          logos: response?.data?.uploadedLogos,
        },
      });
      return response?.data;
    } else {
      const { data } = response.response;
      const { error: message, success } = data;
      return { message, success };
    }
  } catch (error) {
    dispatch({
      type: PROJECT_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
    if (error.response && error.response.data) {
      const { data } = error.response;
      const { error: message, success } = data;
      return { message, success };
    }
  }
};

// Call From Logo update
export const updateProjectCreditItems =
  (creditsId, items) => async (dispatch) => {
    const isCard = JSON.parse(localStorage.getItem("isCard"));
    try {
      dispatch({ type: PROJECT_REQUEST });
      const { _id: projectId } = store.getState().project;
      const { data } = await putRequest(
        `/project/${projectId}/credits/${creditsId}/items`,
        {
          items,
          isCard,
        },
      );
      dispatch({
        type: PROJECT_CREDITS_ITEMS_UPDATE_SUCCESS,
        payload: {
          items: data.items,
          creditsId,
          dataSaved: true,
        },
      });
    } catch (error) {
      dispatch({
        type: PROJECT_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };

// Render Action Call ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const requestRenderXVideo = (images, reqBody) => async (dispatch) => {
  console.log("4 Scroll RenderAPI Call Request => ");
  try {
    dispatch({ type: PROJECT_REQUEST });
    const formData = new FormData();
    images.forEach((image) =>
      formData.append("preview", image.blob, `preview-${image.idx + 1}`),
    );
    Object.keys(reqBody).forEach((key) => formData.append(key, reqBody[key]));
    const { _id: projectId } = store.getState().project;
    const { data } = await postRequest(`/renderx/${projectId}/`, formData);
    console.log('5 Scroll render API Response data => ',data);
    dispatch({
      type: PROJECT_RENDER_REQUEST_SUCCESS,
      payload: { renders: data.renders },
    });
    return data;
  } catch (error) {
    dispatch({
      type: PROJECT_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

export const requestRenderX3Video =
  (images = [], cardScreenOptions = {}, reqBody = {}) =>
    async (dispatch) => {
      console.log("4 Card RenderAPI Call Request => ");
      try {
        dispatch({ type: PROJECT_REQUEST });

        if (!Array.isArray(images) || !reqBody || !cardScreenOptions) {
          throw new Error("Invalid parameters passed.");
        }

        const formData = new FormData();

        images.forEach((image) => {
          if (image?.blob) {
            formData.append(
              "preview",
              image.blob,
              `preview-${image.idx + 1}`,
            );
          }
        });

        formData.append(
          "cardScreenOptions",
          typeof cardScreenOptions === "object"
            ? JSON.stringify(cardScreenOptions)
            : String(cardScreenOptions),
        );

        Object.entries(reqBody).forEach(([key, value]) => {
          if (value == null) return;
          formData.append(
            key,
            typeof value === "object" ? JSON.stringify(value) : String(value),
          );
        });

        const state = store.getState();
        if (!state?.project?._id) {
          throw new Error("Project ID not found in store.");
        }
        const projectId = state.project._id;

        const response = await postRequest(
          `/renderx/card/${projectId}/`,
          formData,
        );
        if (response?.isAxiosError || !(response?.status >= 200 && response?.status < 300)) {
          const message =
            response?.response?.data?.error ||
            response?.response?.data?.message ||
            response?.data?.error ||
            response?.message ||
            "Card render request failed";
          dispatch({
            type: PROJECT_FAIL,
            payload: { error: message },
          });
          return { success: false, error: message };
        }
        const { data } = response;
        console.log('5 Card render API Response data => ',data);
        if (!data?.success) {
          const message = data?.error || data?.message || "Card render request failed";
          dispatch({
            type: PROJECT_FAIL,
            payload: { error: message },
          });
          return { success: false, error: message };
        }
        dispatch({
          type: PROJECT_RENDER_REQUEST_SUCCESS,
          payload: { renders: data.renders },
        });

        return data;
      } catch (error) {
        console.error("Request failed:", error);
        const message =
          error.response?.data?.message ||
          error.message ||
          "Unknown error occurred";
        dispatch({
          type: PROJECT_FAIL,
          payload: { error: message },
        });
        return { success: false, error: message };
      }
    };

export const deleteRenders =
  (projectId, renderId, isCard) => async (dispatch) => {
    try {
      dispatch({ type: PROJECT_REQUEST });
      let response;
      if (isCard) {
        response = await deleteRequest(
          `/project/card/deleteOneRender/${projectId}/${renderId}`,
        );
      } else {
        response = await deleteRequest(
          `/project/deleteOneRender/${projectId}/${renderId}`,
        );
      }
      if (response?.data?.success) {
        dispatch({
          type: RENDER_DELETE_SUCCESS,
          payload: { renderId: response?.data?.RenderId },
        });
      } else {
        dispatch({
          type: RENDER_DELETE_FAIL,
          payload: {
            error: response?.data?.error,
          },
        });
      }
    } catch (error) {
      dispatch({
        type: RENDER_DELETE_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };

//delete all render
export const deleteAllRenders = (projectId) => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_REQUEST });
    const response = await deleteRequest(
      `/project/deleteAllRenders/${projectId}`,
    );
    if (response?.data?.success) {
      dispatch({
        type: RENDER_DELETE_All_SUCCESS,
        payload: { deleterenders: response?.data?.renders },
      });
      return response?.data;
    } else {
      dispatch({
        type: RENDER_DELETE_ALL_FAIL,
        payload: {
          error: response?.data?.error,
        },
      });
      return response?.data;
    }
  } catch (error) {
    dispatch({
      type: RENDER_DELETE_ALL_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

// download render video link
export const downloadRender =
  (projectId, renderId, type) => async (dispatch) => {
    try {
      dispatch({ type: DOWNLOAD_RENDER_REQUEST });
      const isCard = type === "Card" ? true : false;
      let response;
      if (!isCard) {
        response = await getRequest(`/renderx/${projectId}/${renderId}`);
      } else if (isCard) {
        response = await getRequest(`/renderx/card/${projectId}/${renderId}`);
      }
      return response?.data;
    } catch (error) {
      dispatch({
        type: RENDER_DELETE_ALL_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };

export const downloadCardRender = (projectId, renderId) => async (dispatch) => {
  try {
    dispatch({ type: DOWNLOAD_RENDER_REQUEST });
    const response = await getRequest(`/renderx/card/${projectId}/${renderId}`);
    return response?.data;
  } catch (error) {
    dispatch({
      type: RENDER_DELETE_ALL_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// function to fetch all data for helpPage
export const getHelpPageData = () => async (dispatch) => {
  try {
  } catch (error) {
    dispatch({
      type: HELP_PAGE_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

// get stripe data
// get stripe data
export const getUserStripeData = () => async (dispatch) => {
  try {
    const response = await getRequest("/user/getUserStripeDetails");
    if (response.data.success) {
      dispatch({
        type: USER_STRIPE_DATA_SUCCESS,
        payload: response.data,
      });
    } else {
      dispatch({
        type: USER_STRIPE_DATA_FAIL,
        payload: {
          error: response.data.message || "Failed to fetch stripe data",
        },
      });
    }
  } catch (error) {
    console.log(error);
  }
};

// [[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]

export const uploadFontToS3 = (file) => async (dispatch) => {
  const formData = new FormData();
  formData.append("font", file);
  const response = await postRequest("/project/fonts/upload", formData);
  if (response?.data?.success) {
    // Re-fetch full list so Redux has all fonts including the new one
    const listResponse = await getRequest("/project/fonts/user");
    if (listResponse?.data?.success) {
      dispatch({
        type: CUSTOM_FONTS_LOAD_SUCCESS,
        payload: { fonts: listResponse.data.fonts },
      });
    }
  }
  return response?.data;
};

export const fetchUserFonts = () => async (dispatch) => {
  const response = await getRequest("/project/fonts/user");
  if (response?.data?.success) {
    dispatch({
      type: CUSTOM_FONTS_LOAD_SUCCESS,
      payload: { fonts: response.data.fonts },
    });
  }
  return response?.data;
};

export const deleteUserFont = (font) => async (dispatch, getState) => {
  try {
    const response = await deleteRequest("/project/deleteFont", { key: font.key });
    if (response?.data?.success) {
      toast(
        <CustomToast
          title=""
          content={"Font deleted successfully !"}
        />,
        customToatStyle
      );

      // Handle fallback for currently applied styles
      const state = getState();
      const fontStyle = state.project?.fontStyle;
      const isCard = state.project?.isCard;
      const deletedFontFamily = font.fontFamily;
      const fallbackFont = "archivo narrow";

      if (fontStyle) {
        for (const [styleKey, styleValue] of Object.entries(fontStyle)) {
          if (styleValue && styleValue.fontFamily === deletedFontFamily) {
            // Update Redux state locally
            await dispatch(updateFontStyleState(styleKey, "fontFamily", fallbackFont, styleKey));

            // Save updated block to the backend
            await dispatch(saveFontStyle(styleKey, styleKey, "fontFamily", fallbackFont, null, isCard));
          }
        }
      }

      dispatch(fetchUserFonts()); // Refetch fonts after deletion
    } else {
      toast(
        <CustomToast
          title=""
          content={response?.data?.error || "Failed to delete font"}
        />,
        customToatStyle
      );
    }
    return response?.data;
  } catch (error) {
    console.error("Error deleting font:", error);
    toast(
      <CustomToast
        title=""
        content={"Failed to delete font"}
      />,
      customToatStyle
    );
    return { success: false, error: error.message };
  }
};
